module.exports = __webpack_public_path__ + "img/74.448e133b.jpg";